import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { tripEnumObject } from "utils/enumObject";

let env = process.env.REACT_APP_API_BASE_URL;

export const rateCalculationApi = async (data) => {
  let url
  if(data?.type === tripEnumObject?.rental){
    url = `${env}${API_ENDPOINT.CustomerTrip.rateCalculationRentalApi}`
  }else{
    url = `${env}${API_ENDPOINT.CustomerTrip.rateCalculationApi}`
  }
  const res = await requestInstance
    .post(url, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const tripCheckoutApi = async (data) => {
  let url
  if(data?.type === tripEnumObject?.rental){
    url = `${env}${API_ENDPOINT.CustomerTrip.tripRentalApi}`
  }else{
    url = `${env}${API_ENDPOINT.CustomerTrip.tripCheckoutApi}`
  }
  const res = await requestInstance
    .post(url, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const rentalSlabApi = async (data) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.CustomerTrip.rentalSlabApi+'?type='+data?.type+'&sourceAddress='+data?.sourceAddress}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const tripSlabApi =  async (data) =>{
  const res =  await requestInstance
  .get(`${env}${API_ENDPOINT.CustomerTrip.tripSlabApi}?type=${data?.type}&sourceAddress=${data?.sourceAddress}`,
  data)
  .catch((err) => err.response);
  return setCurrentUser(res);
}

export const cancelTripApi = async(data) =>{
  let url = ''
  if(data?.id){
    url = `${env}${API_ENDPOINT.Trip.api+'/'+data?.id}`
  }
  const res = await requestInstance
  .patch(url,data)
  .catch((err) => err.response)
  return setCurrentUser(res)
}

export const cancelReasonApi = async(data) =>{
  const res = await requestInstance
  .get(`${env}${API_ENDPOINT.CustomerTrip.cancelReasonApi}`,data)
  .catch((err) => err.response)
  return setCurrentUser(res);
}


export const refundPriceApi = async(data) =>{
  const res = await requestInstance
  .get(`${env}${API_ENDPOINT.CustomerTrip.refundPriceApi+'/'+data?.id}`,data)
  .catch((err) => err.response)
  return setCurrentUser(res);
}